/**
 * Admin QR codes API — uses adminFetch (same auth as other admin routes).
 */

import { adminFetch } from '@/lib/adminApi';
import type { QRCode, CreateQRCodeRequest, UpdateQRCodeRequest } from '@/types/qrCode';

export async function getAdminQRCodes(
  filters?: { unit_id?: string; is_active?: boolean }
): Promise<{ data: QRCode[] }> {
  const params = new URLSearchParams();
  if (filters?.unit_id) params.set('unit_id', filters.unit_id);
  if (filters?.is_active !== undefined) params.set('is_active', String(filters.is_active));
  const q = params.toString();
  return adminFetch<{ data: QRCode[] }>(`/qr-codes${q ? `?${q}` : ''}`);
}

export async function createAdminQRCode(
  data: CreateQRCodeRequest
): Promise<{ data: QRCode }> {
  return adminFetch<{ data: QRCode }>('/qr-codes', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateAdminQRCode(
  id: string,
  data: UpdateQRCodeRequest
): Promise<{ data: QRCode }> {
  return adminFetch<{ data: QRCode }>(`/qr-codes/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export async function deleteAdminQRCode(id: string): Promise<{ success: boolean }> {
  return adminFetch<{ success: boolean }>(`/qr-codes/${id}`, { method: 'DELETE' });
}

export async function saveQRImage(
  id: string,
  blob: Blob
): Promise<{ data: QRCode }> {
  const formData = new FormData();
  formData.append('image', blob, 'qr-code.png');
  return adminFetch<{ data: QRCode }>(`/qr-codes/${id}/save-image`, {
    method: 'POST',
    body: formData,
  });
}

export async function resetQRStats(id: string): Promise<{ success: boolean }> {
  return adminFetch<{ success: boolean }>(`/qr-codes/${id}/reset-stats`, {
    method: 'POST',
  });
}
